import { useMutation } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

export const useDeleteOrganizationMutation = () => {
  return useMutation({
    mutationFn: (organizationId: string) => {
      return apiClient.user.deleteOrganization({ id: organizationId });
    },
    onError: (error: unknown) => {
      const parsedError = parseApiError(error);
      notify.error(parsedError);
    },
  });
};
